import CodeEditor from './CodeEditor';
import { formatSize } from '../utils/paths';

const LargeFileViewer = ({
  editor,
  onNavigateChunk,
  loading = false,
  languageOverride = 'auto',
  onLanguageChange = () => {},
  softWrap = true,
  onToggleWrap = () => {}
}) => {
  if (!editor?.isLargeFile) return null;

  const totalSize = Number(editor.totalSize) || 0;
  const chunkOffset = Number(editor.chunkOffset) || 0;
  const chunkBytes = Number(editor.chunkBytes) || 0;
  const chunkSize = Number(editor.chunkSize) || 256 * 1024;
  const firstByte = totalSize > 0 ? chunkOffset + 1 : 0;
  const lastByte = chunkOffset + chunkBytes;
  const canPrev = chunkOffset > 0;
  const canNext = lastByte < totalSize;
  const lastChunkOffset = totalSize > 0 ? Math.max(0, totalSize - Math.min(chunkSize, totalSize)) : 0;

  return (
    <div className="h-full min-h-0 flex flex-col gap-3">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-inset/60 px-3 py-2">
        <div className="min-w-0">
          <div className="text-sm font-semibold text-white">Large File Preview</div>
          <div className="text-xs text-textMuted">
            Read-only chunk view for files over 5 MB.
            {' '}
            {totalSize > 0 ? `Showing bytes ${firstByte.toLocaleString()}-${lastByte.toLocaleString()} of ${totalSize.toLocaleString()} (${formatSize(totalSize)}).` : 'Empty file.'}
            {loading ? ' Loading chunk...' : ''}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            className="ghost-button px-3 py-1.5 text-sm"
            onClick={() => onNavigateChunk(0)}
            disabled={loading || !canPrev}>
            Start
          </button>
          <button
            type="button"
            className="ghost-button px-3 py-1.5 text-sm"
            onClick={() => onNavigateChunk(Math.max(0, chunkOffset - chunkSize))}
            disabled={loading || !canPrev}>
            Prev
          </button>
          <button
            type="button"
            className="ghost-button px-3 py-1.5 text-sm"
            onClick={() => onNavigateChunk(chunkOffset + chunkSize)}
            disabled={loading || !canNext}>
            Next
          </button>
          <button
            type="button"
            className="ghost-button px-3 py-1.5 text-sm"
            onClick={() => onNavigateChunk(lastChunkOffset)}
            disabled={loading || !canNext}>
            End
          </button>
        </div>
      </div>
      <div className="flex-1 min-h-0">
        <CodeEditor
          value={editor.content}
          onChange={() => {}}
          path={editor.path}
          languageOverride={languageOverride}
          onLanguageChange={onLanguageChange}
          softWrap={softWrap}
          onToggleWrap={onToggleWrap}
          readOnly />
      </div>
    </div>
  );
};

export default LargeFileViewer;
